

import * as React from "react"
import * as TogglePrimitive from "@radix-ui/react-toggle"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const toggleVariants = cva(
  "vtwo:inline-flex vtwo:items-center vtwo:justify-center vtwo:gap-2 vtwo:rounded-md vtwo:text-sm vtwo:font-medium vtwo:hover:bg-muted vtwo:hover:text-muted-foreground vtwo:disabled:pointer-events-none vtwo:disabled:opacity-50 vtwo:data-[state=on]:bg-accent vtwo:data-[state=on]:text-accent-foreground vtwo:[&_svg]:pointer-events-none vtwo:[&_svg:not([class*=size-])]:size-4 vtwo:[&_svg]:shrink-0 vtwo:focus-visible:border-ring vtwo:focus-visible:ring-ring/50 vtwo:focus-visible:ring-[3px] vtwo:outline-none vtwo:transition-[color,box-shadow] vtwo:aria-invalid:ring-destructive/20 vtwo:dark:aria-invalid:ring-destructive/40 vtwo:aria-invalid:border-destructive vtwo:whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "vtwo:bg-transparent",
        outline:
          "vtwo:border vtwo:border-input vtwo:bg-transparent vtwo:shadow-xs vtwo:hover:bg-accent vtwo:hover:text-accent-foreground",
      },
      size: {
        default: "vtwo:h-9 vtwo:px-2 vtwo:min-w-9",
        sm: "vtwo:h-8 vtwo:px-1.5 vtwo:min-w-8",
        lg: "vtwo:h-10 vtwo:px-2.5 vtwo:min-w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Toggle({
  className,
  variant,
  size,
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> &
  VariantProps<typeof toggleVariants>) {
  return (
    <TogglePrimitive.Root
      data-slot="toggle"
      className={cn(toggleVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Toggle, toggleVariants }
